var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v(
              "Orden de trabajo " +
                _vm._s(_vm.form.tipo_documento) +
                " " +
                _vm._s(_vm.numero_documento === "" ? "" : "-") +
                " " +
                _vm._s(_vm.numero_documento)
            )
          ]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A",
                    expression: "estado === 'A'"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_c("strong", [_vm._v("ABIERTA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "V",
                    expression: "estado === 'V'"
                  }
                ],
                staticClass: "noti-warning"
              },
              [_c("strong", [_vm._v("ASIGNADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "B",
                    expression: "estado === 'B'"
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("FACTURABLE")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "F",
                    expression: "estado === 'F'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("FACTURADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "C",
                    expression: "estado === 'C'"
                  }
                ],
                staticClass: "noti-light"
              },
              [_c("strong", [_vm._v("CERRADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "E",
                    expression: "estado === 'E'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N",
                    expression: "estado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVA")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c("label", { attrs: { for: "por_imap" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.por_imap,
                    expression: "por_imap"
                  }
                ],
                attrs: {
                  disabled: "",
                  type: "checkbox",
                  name: "por_imap",
                  id: "por_imap"
                },
                domProps: {
                  checked: Array.isArray(_vm.por_imap)
                    ? _vm._i(_vm.por_imap, null) > -1
                    : _vm.por_imap
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.por_imap,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.por_imap = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.por_imap = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.por_imap = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Via IMAP")])
            ]),
            _vm._v(" "),
            _c("label", { attrs: { for: "facturable" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ordenFacturable,
                    expression: "ordenFacturable"
                  }
                ],
                attrs: {
                  disabled: _vm.estado !== "C",
                  type: "checkbox",
                  name: "facturable",
                  id: "facturable"
                },
                domProps: {
                  checked: Array.isArray(_vm.ordenFacturable)
                    ? _vm._i(_vm.ordenFacturable, null) > -1
                    : _vm.ordenFacturable
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.ordenFacturable,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.ordenFacturable = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.ordenFacturable = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.ordenFacturable = $$c
                      }
                    },
                    _vm.changeFacturable
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Facturable")])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.puedeConsultar || _vm.puedeAdministrar,
                    expression: "puedeConsultar || puedeAdministrar"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            disabled: !_vm.editable,
                            type: "date",
                            id: "fecha_emision"
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled": !_vm.editable
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "nombre",
                              options: _vm.vendedores,
                              id: "vendedor",
                              placeholder: "Seleccione..."
                            },
                            on: { input: _vm.inputVendedor },
                            model: {
                              value: _vm.selectedVendedor,
                              callback: function($$v) {
                                _vm.selectedVendedor = $$v
                              },
                              expression: "selectedVendedor"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "vendedor" } }, [
                            _vm._v("Vendedor asignado")
                          ]),
                          _vm._v(" "),
                          _vm.errores.vendedor_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.vendedor_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "multiselect-field" },
                      [
                        _c("multiselect", {
                          attrs: {
                            disabled: !_vm.editable,
                            placeholder: "Seleccione...",
                            taggable: "",
                            "tag-placeholder": "Nueva persona",
                            label: "nombre",
                            "track-by": "id",
                            id: "cliente",
                            options: _vm.personas
                          },
                          on: { tag: _vm.addPersona },
                          model: {
                            value: _vm.form.selectedPersona,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selectedPersona", $$v)
                            },
                            expression: "form.selectedPersona"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "cliente" } }, [
                          _vm._v("Persona")
                        ]),
                        _vm._v(" "),
                        _vm.errores.persona_id
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.persona_id[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            readonly: !_vm.editable,
                            maxlength: "1000",
                            placeholder: "Escriba un comentario...",
                            id: "comentario"
                          },
                          model: {
                            value: _vm.form.comentario,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "comentario", $$v)
                            },
                            expression: "form.comentario"
                          }
                        },
                        [
                          _c("span", [_vm._v("Comentario")]),
                          _vm._v(" "),
                          _vm.errores.comentario
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.comentario[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            readonly: true,
                            maxlength: "1000",
                            placeholder: "...",
                            id: "observacion"
                          },
                          model: {
                            value: _vm.observacion,
                            callback: function($$v) {
                              _vm.observacion = $$v
                            },
                            expression: "observacion"
                          }
                        },
                        [_c("span", [_vm._v("Observación")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hayProforma,
                        expression: "hayProforma"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: { readonly: "", id: "numero_proforma" },
                              model: {
                                value: _vm.form.numero_proforma,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "numero_proforma", $$v)
                                },
                                expression: "form.numero_proforma"
                              }
                            },
                            [_vm._v("Proforma")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-info btn--text",
                              on: { click: _vm.verProforma }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.detalles.length > 0,
                  expression: "form.detalles.length > 0"
                }
              ],
              staticClass: "card mt-2"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.form.detalles, function(item, index) {
                        return _c("tr", { key: item.id_item_comprobante }, [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.descripcion_item))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "form-field" },
                              [
                                _c(
                                  "input-field",
                                  {
                                    attrs: {
                                      readonly: !_vm.editable,
                                      id: "cantidad" + item.id_item_comprobante,
                                      vMoney: "",
                                      format: _vm.decimal,
                                      placeholder: "##"
                                    },
                                    model: {
                                      value: item.cantidad,
                                      callback: function($$v) {
                                        _vm.$set(item, "cantidad", $$v)
                                      },
                                      expression: "item.cantidad"
                                    }
                                  },
                                  [
                                    _vm.errores.hasOwnProperty(
                                      "detalles." + index + ".cantidad"
                                    )
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "helper-text text-danger",
                                            attrs: { slot: "helper" },
                                            slot: "helper"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errores[
                                                    "detalles." +
                                                      index +
                                                      ".cantidad"
                                                  ][0]
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "form-field" },
                              [
                                _c(
                                  "input-field",
                                  {
                                    attrs: {
                                      readonly: !_vm.editable,
                                      id: "coste" + item.id_item_comprobante,
                                      vMoney: "",
                                      format: _vm.money,
                                      placeholder: "##"
                                    },
                                    model: {
                                      value: item.coste,
                                      callback: function($$v) {
                                        _vm.$set(item, "coste", $$v)
                                      },
                                      expression: "item.coste"
                                    }
                                  },
                                  [
                                    _vm.errores.hasOwnProperty(
                                      "detalles." + index + ".coste"
                                    )
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "helper-text text-danger",
                                            attrs: { slot: "helper" },
                                            slot: "helper"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errores[
                                                    "detalles." +
                                                      index +
                                                      ".coste"
                                                  ][0]
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.calcularCostoTotal(index))
                              )
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v("Totales")
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.decimalFormat(_vm.cantidadesTotales))
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.moneyFormat(_vm.costosTotales)))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable,
                      expression: "editable"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      _vm.puedeCrear &&
                      _vm.estado === "N" &&
                      !_vm.puedeAdministrar,
                    type: "button"
                  },
                  on: { click: _vm.guardar }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.puedeAdministrar,
                      expression: "puedeAdministrar"
                    }
                  ],
                  staticClass: "btn-light btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.nueva }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nueva")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.anulable,
                      expression: "anulable"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.anular }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.facturable,
                      expression: "facturable"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.facturar }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Facturar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cerrable,
                      expression: "cerrable"
                    }
                  ],
                  staticClass: "btn-warning btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.cerrar }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Cerrar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$modal.show("auditorias")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-file-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Logs")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimir }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anterior")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Siguiente")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaOrdenesTrabajo",
            height: "auto",
            width: "85%",
            scrollable: ""
          }
        },
        [
          _c("lista-ordenes-trabajo", {
            on: { selected: _vm.selectedOrdenTrabajo }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "auditorias",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("auditorias", {
            ref: "auditorias",
            attrs: { id_comprobante: _vm.id },
            on: { cancelar: _vm.cancelarAuditorias }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "observacionOT",
            height: "auto",
            scrollable: "",
            width: "70%"
          }
        },
        [
          _c("observacion-ot", {
            attrs: { id: _vm.id },
            on: { cancelar: _vm.cancelarOt, cerrada: _vm.ordenCerrada }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Detalle de orden de trabajo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Item")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Costo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Costo total")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Cantidades totales")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Costos totales")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0951ce1e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0951ce1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ordenes-trabajo/OrdenTrabajo.vue
// module id = 589
// module chunks = 0